module.exports = __webpack_public_path__ + "img/veb-rf-ru.1932afa.svg";